var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid main-menu" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-lg-12 menu-item" },
        [
          _c("router-link", { attrs: { to: { name: "scan-produced" } } }, [
            _c("div", { staticClass: "btn btn-produced btn-full-width" }, [
              _c("div", { staticClass: "btn-first-line" }, [_vm._v("scannen")]),
              _vm._v(" "),
              _c("div", { staticClass: "btn-primary-line" }, [
                _vm._v("GEPRODUCEERD")
              ])
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-lg-12 menu-item" },
        [
          _c("router-link", { attrs: { to: { name: "scan-packing" } } }, [
            _c("div", { staticClass: "btn btn-pick btn-full-width" }, [
              _c("div", { staticClass: "btn-first-line" }, [_vm._v("scannen")]),
              _vm._v(" "),
              _c("div", { staticClass: "btn-primary-line" }, [
                _vm._v("INPAKKEN")
              ])
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-lg-12 menu-item" },
        [
          _c(
            "router-link",
            { attrs: { to: { name: "production-item-info" } } },
            [
              _c("div", { staticClass: "btn btn-item-info btn-full-width" }, [
                _c("div", { staticClass: "btn-first-line" }, [
                  _vm._v("scannen")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "btn-primary-line" }, [
                  _vm._v("PRODUCTIE INFO")
                ])
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-lg-12 menu-item" },
        [
          _c("router-link", { attrs: { to: { name: "packing-slip-info" } } }, [
            _c("div", { staticClass: "btn btn-shipping-info btn-full-width" }, [
              _c("div", { staticClass: "btn-first-line" }, [_vm._v("scannen")]),
              _vm._v(" "),
              _c("div", { staticClass: "btn-primary-line" }, [
                _vm._v("PAKBON INFO")
              ])
            ])
          ])
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-beffe230", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-beffe230","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainMenu.vue
// module id = Qod3
// module chunks = 1